'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dSealed$0024package$0024$002dHorse$00241 from "./samples.-Sealed$package$-Horse$1.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$$anon$6$$anon$15() {
}
export { $c_Lsamples_Sealed$package$$anon$6$$anon$15 as $c_Lsamples_Sealed$package$$anon$6$$anon$15 };
$p = $c_Lsamples_Sealed$package$$anon$6$$anon$15.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$$anon$6$$anon$15;
/** @constructor */
function $h_Lsamples_Sealed$package$$anon$6$$anon$15() {
}
export { $h_Lsamples_Sealed$package$$anon$6$$anon$15 as $h_Lsamples_Sealed$package$$anon$6$$anon$15 };
$h_Lsamples_Sealed$package$$anon$6$$anon$15.prototype = $p;
$p.b = (function() {
  return "<function1>";
});
$p.cq = (function(x$0) {
  this.jk(null);
});
$p.jk = (function(a) {
  return ((a instanceof $j_samples$002e$002dSealed$0024package$0024$002dHorse$00241.$c_Lsamples_Sealed$package$Horse$1) && (a !== null));
});
$p.j = (function(v1) {
  return this.jk(v1);
});
var $d_Lsamples_Sealed$package$$anon$6$$anon$15 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$$anon$6$$anon$15, "samples.Sealed$package$$anon$6$$anon$15", ({
  qh: 1,
  o: 1,
  a: 1,
  bf: 1
}));
export { $d_Lsamples_Sealed$package$$anon$6$$anon$15 as $d_Lsamples_Sealed$package$$anon$6$$anon$15 };
